import api from 'api'

const FETCH_REQUEST = 'realhub/chart/approvedOrders/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/chart/approvedOrders/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/chart/approvedOrders/FETCH_FAILURE'


// Initial State
const initialState = {
  result: {
    total: 0,
    count: 0,
    data: [],
  },
  loaded: false,
  loading: false,
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadApprovedOrders(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())


    const formattedOptions = {
      ...options,
      start_date: options.start_date.format('YYYY-MM-DD'),
      end_date: options.end_date.format('YYYY-MM-DD'),
    }

    const promise = api('/charts/orders/approved.json', formattedOptions)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type, payload, errors } = action

  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        result: { ...payload },
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...initialState,
        errors,
      }
    default:
      return state
  }
}
